<div class="big-wrapper">
    <div class="info">{{ getNameToDisplay | translate | capitalizeFirst }}</div>
    <div class="violation-icons-wrapper">
        <ng-container *ngFor="let idViolation of violationsIds">
            <div (click)="toggleSelectedIdViolation(idViolation)" class="violation-icon hover"
                [ngClass]="idViolation === selectedIdViolation ? 'selected-violation' : ''">
                <div matBadge="{{ countSelected(idViolation) }}"
                     matBadgeSize="small"
                     matBadgeOverlap="true"
                     matBadgeColor="warn">
                    <div class="no-copy" [innerHTML]="getViolationSymbol(idViolation)"></div>
                </div>
            </div>
        </ng-container>
    </div>

    <div class="separator-container">
        <ng-container *ngIf="!disabled && selectedIdViolation != null">
            <div class="select-all-container">
                <mat-checkbox style="scale: 0.8;" (change)="toggleAllSelectedForViolation(selectedIdViolation, $event.checked)"
                    [checked]="isAllSelectedByViolation(selectedIdViolation)"></mat-checkbox>
                <div>{{ 'sakp.departures.add-reclamation-dialog.select-all-by-violation' | translate }}</div>
            </div>
        </ng-container>

        <ng-container *ngIf="!disabled && selectedIdViolation == null && allDepartures.length > 0">
            <div class="select-all-container">
                <mat-checkbox style="scale: 0.8;" (change)="toggleAllViolations($event.checked)"
                    [checked]="isSelectedAllViolations()"></mat-checkbox>
                <div>{{ 'sakp.departures.add-reclamation-dialog.select-all' | translate }}</div>
            </div>
        </ng-container>

        <div class="separator" style="flex: 1;"></div>
        <div class="select-all-container">
            <span>{{ (disabled ? 'sakp.departures.add-reclamation-dialog.quantity' : 'sakp.departures.add-reclamation-dialog.selected') | translate }}: {{ countSelected(selectedIdViolation) }}</span>
        </div>
        <div class="separator" style="width: 30px;"></div>
    </div>

    <cdk-virtual-scroll-viewport class="departures-list" [itemSize]="itemSize" minBufferPx="600" maxBufferPx="1200">
        <div *cdkVirtualFor="let departure of visibleDepartures; trackBy: departureTrackBy" class="departure-wrapper"
            [ngClass]="decisionClass(departure)">
            <div class="departure-content">
                <label class="checkbox" *ngIf="!disabled">
                    <mat-checkbox *ngIf="!disabled" [disabled]="disabled"
                        (change)="toggleSelectedDeparture($event.source.value, $event.checked)" [value]="departure"
                        [checked]="isDepartureSelected(departure)">
                    </mat-checkbox>
                </label>        
                <div class="grid-container">
                    <div class="grid-header">
                        <span class="id-departure">{{ departure.id }}</span>
                        <span class="id-claim">{{ departure.idClaim }}</span>
                    </div>

                    <div class="grid-leftbar">
                        <!-- <div class="violation-icon" *ngIf="selectedIdViolation == null">
                            <div class="no-copy" [innerHTML]="getViolationSymbol(departure.idViolation)"></div>
                        </div> -->
                        <div class="violation-icon">
                            <div class="no-copy" [innerHTML]="getViolationSymbol(departure.idViolation)"></div>
                        </div>
                    </div>

                    <!-- Poziome przewijanie długich tekstów: natywny pasek jest ukryty (zmieniałby wysokość
                         wiersza, a wirtualny scroll wymaga jednakowej), jego rolę pełni nakładkowy uchwyt. -->
                    <div class="grid-main-wrapper" [appOverlayScrollbar]="departure.id">
                        <div class="grid-main overlay-scroll-content">
                            <div class="vehicle" [matTooltip]="rowLabels.vehicle">
                                {{ departure.vehicle || rowLabels.noVehicle }}
                            </div>
                            <div class="day" [matTooltip]="rowLabels.day">
                                {{ departure.day }}
                            </div>
                            <div class="task" [matTooltip]="rowLabels.task">
                                {{ departure.task }}
                            </div>
                            <div class="line" [matTooltip]="rowLabels.line">
                                {{ departure.line }}
                            </div>
                            <div class="direction" [matTooltip]="rowLabels.direction">
                                {{ departure.direction }}
                            </div>
                            <div class="stop-name" [matTooltip]="rowLabels.stopName">
                                {{ departure.stop }}
                            </div>
                            <div class="stop-time" [matTooltip]="rowLabels.stopTime">
                                {{ departure.time }}
                            </div>
                            <div class="course-time" [matTooltip]="rowLabels.courseTime">
                                {{ departure.course }}
                            </div>
                        </div>
                        <div class="overlay-scroll-thumb"></div>
                    </div>
        
                    <div class="grid-rightbar" *ngIf="canDecide">
                        <div class="override-decision-buttons" *ngIf="canDecide">
                            <div class="the-button" [class.disabled]="disableDecisionButtons" (click)="handleClickOverrideDecision(departure.idClaim, 'REJECTED')"
                                [matTooltip]="rowLabels.decisionRejected">
                                <i class="prime-icon pi pi-thumbs-down"></i>
                            </div>
                            <div class="the-button" [class.disabled]="disableDecisionButtons" (click)="handleClickOverrideDecision(departure.idClaim, 'ACCEPTED')"
                                [matTooltip]="rowLabels.decisionAccepted">
                                <i class="prime-icon pi pi-thumbs-up"></i>
                            </div>
                            <div class="the-button" [class.disabled]="disableDecisionButtons" (click)="handleClickRemoveDecisionOverride(departure.idClaim)"
                                [matTooltip]="rowLabels.decisionRevoke">
                                <i class="prime-icon pi pi-undo"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="decision-override-panel" *ngIf="reserveDecisionPanel"
                [ngClass]="{
                    'approved': departure.decisionOverride === 'APPROVED',
                    'rejected': departure.decisionOverride === 'REJECTED'
                }">
                <ng-container *ngIf="departure.decisionOverride">
                    <i class="prime-icon pi"
                        [ngClass]="departure.decisionOverride === 'REJECTED' ? 'pi-thumbs-down' : 'pi-thumbs-up'"></i>
                    <span>
                        {{
                            'sakp.disputes.filed.claim-card.decision-override' | translate: {
                                whom: departure.decisionOverridenBy | sakpUser,
                                when: departure.decisionOverridenAt | date: 'dd.MM.yyyy HH:mm:ss'
                            }
                        }}
                    </span>
                </ng-container>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</div>
